<script lang='ts'>
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  export let storefront : Storefront;
  export let callbacks: any;

  function update() {
    callbacks.update(storefront);
  }

</script>

<section class='fizz-text-small'>
  <p class="fizz-label fizz-stack-8 fizz-space-between">
    <span>Website</span>
  </p>
  <input
    id='storefront-footer-website'
    bind:value={storefront.website_link}
    on:change={update}
    class="fizz-input-text fizz-stack-16 fizz-full-width"
    type="text"
    placeholder="www.example.com"
  />
  <p class="fizz-label fizz-stack-8 fizz-space-between">
    <span>Twitter</span>
  </p>
  <input
    id='storefront-footer-facebook'
    bind:value={storefront.twitter_link}
    on:change={update}
    class="fizz-input-text fizz-stack-16 fizz-full-width"
    type="text"
    placeholder="www.twitter.com/example"
  />
  <p class="fizz-label fizz-stack-8 fizz-space-between">
    <span>Facebook</span>
  </p>
  <input
    id='storefront-footer-twitter'
    bind:value={storefront.facebook_link}
    on:change={update}
    class="fizz-input-text fizz-stack-16 fizz-full-width"
    type="text"
    placeholder="www.facebook.com/example"
  />
  <p class="fizz-label fizz-stack-8 fizz-space-between">
    <span>Instagram</span>
  </p>
  <input
    id='storefront-footer-instagram'
    bind:value={storefront.instagram_link}
    on:change={update}
    class="fizz-input-text fizz-stack-16 fizz-full-width"
    type="text"
    placeholder="www.instagram.com/example"
  />
</section>